import { React } from "react";

import MobilePage from "./MobilePage";

export const MobileRegularPage = (props) => (
    <MobilePage color="secondary.main">
        {props.children}
    </MobilePage>
);

